module.exports = __webpack_public_path__ + "img/customer01.99f7abc.png";